import { FirestoreDataConverter, Timestamp } from 'firebase/firestore';
import { SupportedLanguage } from '../main';
import { Entity } from './entity';

export interface ReadingContent {
  title: string;
  text: string; // Markdown
}

// Supported Markdown syntax
// h1: #
// h2: ##
// h3: ###
// block quote: >
// bold: **text**
// italic: _text_
// divider: ---
// url: [text](url)
// list: - or 1.

export interface DailyReading extends Entity {
  date?: Date;
  de: ReadingContent;
  en?: ReadingContent;
  fr?: ReadingContent;
  it?: ReadingContent;
}

export function getReadingContent(reading: DailyReading, language: string): ReadingContent {
  const lang = language as SupportedLanguage;
  return reading[lang] || reading.de;
}

export interface FirestoreDailyReading extends Omit<DailyReading, 'date'> {
  date?: Timestamp;
}

export const DailyReadingConverter: FirestoreDataConverter<DailyReading, FirestoreDailyReading> = {
  toFirestore: (reading: DailyReading): FirestoreDailyReading => {
    return {
      ...reading,
      date: reading.date && Timestamp.fromDate(reading.date),
    };
  },
  fromFirestore: (snapshot, options): DailyReading => {
    const reading = snapshot.data(options) as FirestoreDailyReading;
    return {
      ...reading,
      date: reading.date?.toDate(),
    };
  },
};

export const DailyReadingCollection = 'readings-daily';
